import { theme } from "aaa";
import { SigningComponent } from "components/signing/views/SigningComponent";
import { observer } from "mobx-react";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { JuniorRoutes } from "../JuniorRoutes";
import { JuniorStore } from "../JuniorStore";
import { SigningJuniorCard } from "../components/cards/SigningJuniorCard";

type IProps = {
    store: JuniorStore;
};

export const JuniorActivateSigning = observer(({ store }: IProps) => {
    const childName = store.selectedChild?.name ?? "";
    return (
        <SigningComponent
            useWebVersion
            signingInfo={store.activationInfo?.signInfo}
            content={
                <div style={{ padding: theme.MARGIN }}>
                    <SigningJuniorCard childName={childName} />
                </div>
            }
            onSuccess={async (response: ISigningResponse) => {
                await store.loadData()
                pushRoute(JuniorRoutes.ACTIVATE_SUCCESS);
            }}
            onError={async (error: any) => {
                pushRoute(JuniorRoutes.ACTIVATE_ERROR);
            }}
            onRetry={async () => await store.activateJunior()}
            onClose={() => pushRoute(JuniorRoutes.ACTIVATE_TOUR)}
        />
    );
});


// WEBPACK FOOTER //
// ./src/components/gJunior/activateStep/JuniorActivateSigning.tsx